import { render, staticRenderFns } from "./ShapeModel.vue?vue&type=template&id=1908a806&scoped=true"
import script from "./ShapeModel.vue?vue&type=script&lang=js"
export * from "./ShapeModel.vue?vue&type=script&lang=js"
import style0 from "./ShapeModel.vue?vue&type=style&index=0&id=1908a806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908a806",
  null
  
)

export default component.exports